import React                  from 'react';
import { Observe }                 from 'rewire-core';
import SettingsModel               from './SettingsModel';
import { Theme, makeStyles }       from '../utility/styles';
import { IInfoPanelProps }         from '../ui/InfoPanel';
import {
  DefaultEditPanelView,
}                                  from './DefaultSettingsView';

const useTemplateEditPanelViewStyles = makeStyles((_theme: Theme) => ({
  infoPanelRoot: {
  },
}));

const TemplateEditPanelView = ({ settings, classes, InfoPanelProps }: { settings: SettingsModel, classes?: any, InfoPanelProps?: IInfoPanelProps }) => {
  const templateEditPanelClasses = useTemplateEditPanelViewStyles({classes});
  return <Observe render={() => (
    <DefaultEditPanelView InfoPanelProps={InfoPanelProps} settings={settings} classes={templateEditPanelClasses} />
  )} />;
};

TemplateEditPanelView.defaultProps = {
  InfoPanelProps: {
    defaultSize: {
      width: 400,
      height: '100%',
    },
    minWidth: 400,
  }
};

export default TemplateEditPanelView;